import { serializable, alias, primitive, custom } from "serializr";

export class AdminFeature {
  @serializable(alias("feature_id", primitive()))
  featureId?: number;

  @serializable(alias("feature", primitive()))
  feature?: string;
}
